module.exports = __webpack_public_path__ + "img/client15.f7353be2.png";